import * as React from "react";
import type { SVGProps } from "react";
const SvgStatsLight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16" {...props}
  >
    <path
      fill="#23F6E7"
      d="M9.08 1a2 2 0 0 1 1.457.63l1.92 2.043A2 2 0 0 1 13 5.043v8.312a.67.67 0 0 1-.178.456.6.6 0 0 1-.429.189H3.607a.6.6 0 0 1-.428-.19.67.67 0 0 1-.179-.455V1.645C3 1.289 3.272 1 3.607 1z"
      opacity={0.2}
    />
    <path
      fill="#23F6E7"
      d="M7.444 10.75v-6.5h1.223v6.5zM9.889 10.75v-3.9h1.222v3.9zM5 10.75v-2.6h1.222v2.6z"
    />
  </svg>
);
export default SvgStatsLight;
